export default [
  {
    likes: "25",
    title: "Furnitures",
    date: "02/04/2015",
    uploadedby: "Harsh Dedhia"
  },
  {
    likes: "25",
    title: "Furnitures",
    date: "02/04/2015",
    uploadedby: "Harsh Dedhia"
  },
  {
    likes: "25",
    title: "Accessories",
    date: "02/04/2015",
    uploadedby: "Harsh Dedhia"
  },
  {
    likes: "25",
    title: "Home Décor",
    date: "02/04/2015",
    uploadedby: "Harsh Dedhia"
  }
];
